module.exports = __webpack_public_path__ + "static/media/light2.ce152ec1.png";